export const TOOLBAR_SPACE = 'toolbar-space';
export const TOOLBAR_SPACE_HIDDEN = 'toolbar-space toolbar-space-hidden';
